/**
 * Check if the given answer is correct
 * @param question - question to check the answer against
 * @param currentAnswer - answer to be checked for correctness
 * @returns boolean
 */
export const isAnswerCorrect = (question, currentAnswer) => {
    let answerId = currentAnswer.questionAnswerId.$oid;
    let answer = question.answers.find(current => current.questionAnswerId.$oid === answerId);
    return answer != null ? answer.correct : false;
};

/**
 * Get the total number of correct student answers for all questions in a given set
 * @param questions - set of questions to check
 * @returns int
 */
export function getNumberOfCorrectAnswers(questions){
    return questions.reduce(
        (accumulator, current) => getPerQuestionCorrectStudentAnswers(current) + accumulator ,0);
}

/**
 * Get the total number of points available for all questions in a given set
 * @param questions - set of questions to check
 * @returns int
 */
export function getTotalNumberOfPoints(questions){
    return questions.reduce( (total, question) => total + getQuestionPoints(question), 0);
}

/**
 * Get the total number of points available for a single question
 * @param question
 * @returns int
 *
 * No part marks = change to the question
 */
export function getQuestionPoints(question) {
    // let total = question.answers.reduce(
    //     (perQuestionTotal, answer) =>
    //         (answer.correct ? perQuestionTotal + 1 : perQuestionTotal), 0);
    // return total > 1 ? total : 1;
    return 1;
}

/**
 * Calculate the percent points received by a student for a given quiz - rounded to 0 decimal places
 * @param quizDataDict
 * @returns string
 */
export function calculateScore(quizDataDict){
    if (quizDataDict.questions.length > 0) {
        return (100 * (getNumberOfCorrectAnswers(quizDataDict.questions) / getTotalNumberOfPoints(quizDataDict.questions)))
            .toFixed(0);
    }
    return '0';
}

/**
 * Get the total number of correct answers by a student for a single question
 * @param question
 * @returns int
 */
export function getPerQuestionCorrectStudentAnswers(question) {
    let numCorrectAnswers = 0;
    if (question.studentAnswer != null) {
        if (question.studentAnswer.correct) {
            numCorrectAnswers = 1;
        }
    }
    else if (question.studentAnswers != null) {
        let studentAnswerIds = question.studentAnswers.map(a => a._id.$oid);
        let isCorrect = question.answers.reduce((currentlyCorrect, answer) =>
            studentAnswerIds.includes(answer._id.$oid) ?
                (answer.correct ? currentlyCorrect : false) :
                (answer.correct ? false : currentlyCorrect), true);
        numCorrectAnswers = isCorrect ? 1 : 0;
    }

    // For scoring multi-answer questions w/ one point per answer
    // } else if (question.studentAnswers != null) {
    //     numCorrectAnswers = question.studentAnswers.reduce((total, answer) =>
    //         answer.correct ? total + 1 : total, 0);
    // }
    return numCorrectAnswers;
}
